import React from 'react'
import { BreadcrumbList, ListItem } from 'schema-dts'
import { ITaxonomyWithoutChildren } from '@core/api/Categories/types'
import routes from '@core/config/routes'
import { JsonLd } from '@core/utils/jsonld'

interface IProps {
  breadcrumbs: ITaxonomyWithoutChildren[]
}

const LYSBreadcrumbJsonLd: React.FC<IProps> = ({ breadcrumbs }) => {
  const items: ListItem[] = (breadcrumbs || []).map((cat, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    item: {
      '@type': 'Thing',
      '@id': routes.taxonomy(cat).as!,
      name: cat.name,
    },
  }))

  return (
    <JsonLd<BreadcrumbList>
      item={{
        '@context': 'https://schema.org',
        '@type': 'BreadcrumbList',
        itemListElement: items,
      }}
    />
  )
}

export default LYSBreadcrumbJsonLd
